import React from 'react';
import { Header } from '../components/Header';
import { CtaBanner } from '../components/CtaBanner';
import { ArticleBody } from '../components/ArticleBody';
export function AdvertorialPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-194">
      <Header data-id="element-195" />
      <CtaBanner data-id="element-196" />

      <main className="px-4 py-8 md:py-12" data-id="element-197">
        <ArticleBody data-id="element-198" />
      </main>

      <footer className="bg-slate-100 border-t border-slate-200 py-12 px-4 mt-12" data-id="element-199">
        <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-200">
          <div className="text-sm text-slate-500 space-y-4" data-id="element-201">
            <p data-id="element-202">
              This is a sponsored advertorial by FlossFocus. Individual results
              may vary. The DeepClean Flow is not intended to diagnose, treat,
              cure, or prevent any dental condition. Consult your dental
              professional for personalized oral health advice.
            </p>
            <div className="flex justify-center gap-6 pt-4" data-id="element-203">
              <a href="#" className="hover:text-slate-900 underline" data-id="element-204">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-slate-900 underline" data-id="element-205">
                Terms of Service
              </a>
              <a href="#" className="hover:text-slate-900 underline" data-id="element-206">
                Contact Us
              </a>
            </div>
            <p className="pt-4" data-id="element-207">© 2026 FlossFocus. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
}